import {Injectable, NgZone} from '@angular/core';
import * as RecordRTC from 'recordrtc';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class RecorderService {
  mediaRecorder: RecordRTC;
  activeRecording: boolean;
  currentBlob: any;
  currentUrl: SafeUrl;

  constructor(private sanitizer: DomSanitizer, private ngZone: NgZone) {
    this.activeRecording = false;
  }

  private initRecorder(stream): void {
    this.mediaRecorder = RecordRTC(stream, {
      type: 'video',
      mimeType: 'video/webm',

      // both for audio and video tracks
      // bitsPerSecond: 128000,

      // only for audio track
      // audioBitsPerSecond: 128000,

      // only for video track
      videoBitsPerSecond: 128000,

      // used by CanvasRecorder and WhammyRecorder
      // it is kind of a "frameRate"
      frameInterval: 30,

      // used by CanvasRecorder and WhammyRecorder
      // you can pass {width:640, height: 480} as well
      video: HTMLVideoElement,

      // used by CanvasRecorder and WhammyRecorder
      canvas: {
        width: 640,
        height: 480
      },

      // used by StereoAudioRecorder
      // the range 22050 to 96000.
      sampleRate: 22050,

      // used by StereoAudioRecorder
      // the range 22050 to 96000.
      // let us force 16khz recording:
      desiredSampRate: 16000,

      // used by StereoAudioRecorder
      // Legal values are (256, 512, 1024, 2048, 4096, 8192, 16384).
      // bufferSize: 16384,
      bufferSize: 256,
      // used by StereoAudioRecorder
      // 1 or 2
      numberOfAudioChannels: 1,

      // used by WebAssemblyRecorder
      frameRate: 30,

      // used by WebAssemblyRecorder
      bitrate: 228000,
    });
  }

  public startRecording(stream): void {
    console.log('startRecording');
    this.initRecorder(stream);
    this.activeRecording = true;
    this.mediaRecorder.startRecording();
  }

  private base64FromBlob(blob, onFinish): void {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      onFinish(reader.result);
    };
  }

  public stopRecording(onSuccess = null): void {
    if (this.isRecorderActive) {
      this.activeRecording = false;
      if (this.mediaRecorder) {
        if (this.mediaRecorder.state === 'recording') {
          this.mediaRecorder.stopRecording(() => {
            this.currentBlob = this.mediaRecorder.getBlob();
            this.ngZone.run(() => {
              this.currentUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.currentBlob));
            });
            if (onSuccess) {
              onSuccess();
            }
          });
        }
      }
    }
  }

  public get isRecorderActive(): boolean {
    return this.activeRecording;
  }
}
